import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import styles from './DocumentTagsStrip.m.sass';
var DocumentTagsStrip = function DocumentTagsStrip(_ref) {
  var tags = _ref.tags;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.tags)
  }, tags.length > 3 ? /*#__PURE__*/React.createElement(TagCount, {
    tags: tags
  }) : tags.map(function (tag) {
    return /*#__PURE__*/React.createElement(DocumentTag, {
      key: tag.id,
      tag: tag
    });
  }));
};
var TagCount = observer(function (_ref2) {
  var tags = _ref2.tags;
  return /*#__PURE__*/React.createElement("div", {
    title: tags.map(function (x) {
      return x.label;
    }).join(', '),
    className: styles.tagCount
  }, tags.length, " tags");
});
export var DocumentTag = observer(function DocumentTag(_ref3) {
  var tag = _ref3.tag;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.tag
  }, tag.label);
});
export default observer(DocumentTagsStrip);
//# sourceMappingURL=index.js.map
